import React, { PureComponent } from 'react';
import { camelCase } from 'lodash';
import { TextField, Button, Grid, withStyles } from '@material-ui/core';

const styles = theme => ({
  root: {
    padding: theme.spacing(2),
    '& button': {
      marginTop: theme.spacing(2)
    }
  }
});

class SectionForm extends PureComponent {
  state = {
    name: '',
    key: ''
  };

  handleChange = name => e => {
    const { value } = e.target;
    this.setState({
      [name]: value,
      key: camelCase(value)
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.onSave(this.state);
  };

  render() {
    return (
      <form className={this.props.classes.root} onSubmit={this.handleSubmit}>
        <TextField
          autoFocus
          fullWidth
          id="name"
          label="Name"
          value={this.state.name}
          onChange={this.handleChange('name')}
          margin="normal"
        />

        {/* <TextField
          readOnly
          disabled
          fullWidth
          id="key"
          label="Key"
          value={this.state.key}
          margin="normal"
        /> */}

        <Button fullWidth type="submit" variant="contained" color="primary">
          Save
        </Button>
      </form>
    );
  }
}

export default withStyles(styles)(SectionForm);
